import ReactPlayer from 'react-player';
import { RootStateOrAny, useSelector } from 'react-redux';
import Link from 'next/link';
import { RightOutlined } from '@ant-design/icons';
import { Breadcrumb, Col, Grid, Row, Typography } from 'antd';

import ImageC from 'src/components/Image';
import { Title } from 'src/components/Layout/Typography';

import classes from './about.module.css';

const { Item } = Breadcrumb;
const { Text } = Typography;

const About = () => {
	const { md, lg } = Grid.useBreakpoint();
	const { about } = useSelector((state: RootStateOrAny) => state);
	const dataAbout = about?.about?.data?.records || [];

	return (
		<div className={classes.about}>
			{dataAbout[0] &&
				dataAbout?.slice(0, 1)?.map((item: any, index: number) => {
					return (
						<div key={index} className={classes.breadcrumb}>
							<div className="container space-y-12 md:space-y-20!">
								<Row>
									<Col span={24}>
										<Breadcrumb separator={<RightOutlined className={classes.arrow} />}>
											<Item>
												<Link href="/" className={classes.link}>
													Home
												</Link>
											</Item>

											<Item>
												<Text className="text-white">{item.section}</Text>
											</Item>
										</Breadcrumb>
									</Col>
								</Row>
								<Row
									className={classes['breadcrumb-detail']}
									justify={lg ? 'space-between' : 'center'}
								>
									<Col xs={20} lg={11}>
										<Title level={2} className="mb-2">
											<div
												className={classes.motto}
												dangerouslySetInnerHTML={{ __html: item.title }}
											/>
										</Title>
										<Text>
											<div
												className={classes.quote}
												dangerouslySetInnerHTML={{ __html: item.description }}
											/>
										</Text>
									</Col>
									<Col className={classes['container-video']} xs={24} lg={11}>
										<ReactPlayer
											url={item.url}
											controls={true}
											height={md ? 255 : 195}
											width={md ? 450 : 350}
										/>
									</Col>
								</Row>
							</div>
						</div>
					);
				})}
			{dataAbout[1] &&
				dataAbout?.slice(1, 2)?.map((item: any, index: number) => {
					return (
						<div key={index} className="container mt-12">
							<Title>
								<div className={classes.title} dangerouslySetInnerHTML={{ __html: item.title }} />
							</Title>
							<Text>
								<div
									className={classes.description}
									dangerouslySetInnerHTML={{ __html: item.description }}
								/>
							</Text>
							<div className={classes['container-img']}>
								<ImageC
									className={classes.image}
									src={item.url}
									alt={item.title}
									fill
									style={{ objectFit: 'cover' }}
								/>
							</div>
						</div>
					);
				})}
		</div>
	);
};

export default About;
